// Long file names differ at the END (container no., counts, "英国海运FCL.pdf"), so truncating the
// tail makes near-identical names indistinguishable. Keep the last `tailChars` characters always
// visible and let only the head shrink; the full name is in the hover tooltip.
export default function MiddleEllipsis({ text, tailChars = 26, className = '' }: {
  text: string
  tailChars?: number
  className?: string
}) {
  const chars = Array.from(text)
  const split = chars.length > tailChars * 1.5 ? chars.length - tailChars : chars.length
  const head = chars.slice(0, split).join('')
  const tail = chars.slice(split).join('')
  return (
    <span className={`flex min-w-0 ${className}`} title={text}>
      <span className="truncate">{head}</span>
      {tail && <span className="shrink-0 whitespace-pre">{tail}</span>}
    </span>
  )
}
